export const loadFlickity = require('bundle-loader?lazy&name=flickity!flickity');
export const loadYoutube = require('bundle-loader?lazy&name=[name]!youtube-player');
export const loadVimeo = require('bundle-loader?lazy&name=[name]!@vimeo/player');
export const loadGsap = require('bundle-loader?lazy&name=gsap!gsap');
export const loadAxios = require('bundle-loader?lazy&name=axios!axios');
export const loadGsapFull = require('bundle-loader?lazy&name=gsapFull!./async-bundles/gsap-full');
